import Vue from 'vue';

import constants from '@/constants';

const getTranslatedString = (text) => {
  if (typeof text === 'string') {
    return text;
  }

  if (typeof text !== 'object' || text == null) {
    return null;
  }

  const locale = Vue.i18n.locale();

  return text[locale] || text[constants.locale.default] || text[constants.locale.fallback] || Object.values(text)[0];
};

export default getTranslatedString;



// WEBPACK FOOTER //
// ./src/utils/getTranslatedString.js